import React from 'react';
import { Navigate } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import AdminBillingNav from '@/components/adminBilling/AdminBillingNav';
import { adminBillingService } from '@/api/services/adminBilling';
import { getAccessToken } from '@/api/client';
import { useMe } from '@/context/MeContext';
import { DataTableScrollArea } from '@/components/table';

const API_BASE = process.env.REACT_APP_API_URL ?? '';

const REPORTS = [
  { type: 'revenue', label: 'Revenue' },
  { type: 'subscriptions', label: 'Subscriptions' },
  { type: 'payments', label: 'Payments' },
  { type: 'organizations', label: 'Organizations' },
  { type: 'plans', label: 'Plans' },
  { type: 'usage', label: 'Usage' },
];

async function downloadReport(reportType: string, fmt: 'csv' | 'json') {
  const token = getAccessToken();
  const url = `${API_BASE}${adminBillingService.exportReport(reportType, fmt)}`;
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`Export failed (${res.status})`);
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${reportType}-report.${fmt}`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export default function AdminBillingExportsPage() {
  const { me } = useMe();

  if (!me?.permissions.canExportAdminBilling) {
    return <Navigate to="/admin/billing" replace />;
  }

  return (
    <div className="admin-billing-page">
      <AdminBillingNav />
      <PageHeader title="Exports" subtitle="Download billing reports as CSV or JSON." />
      <section className="panel">
        <DataTableScrollArea>
        <table className="data-table">
          <thead>
            <tr>
              <th>Report</th>
              <th>CSV</th>
              <th>JSON</th>
            </tr>
          </thead>
          <tbody>
            {REPORTS.map((r) => (
              <tr key={r.type}>
                <td>{r.label}</td>
                <td>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => downloadReport(r.type, 'csv')}>
                    Download CSV
                  </button>
                </td>
                <td>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => downloadReport(r.type, 'json')}>
                    Download JSON
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </DataTableScrollArea>
      </section>
    </div>
  );
}
